import styles from "./loadingBar.module.css";

export const LoadingBar = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.loaderBar}></div>
    </div>
  );
};
